import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  
  templateUrl: './book-receipt-indetail-officer.component.html',
  styleUrl: './book-receipt-indetail-officer.component.scss'
})
export class BookReceiptIndetailOfficerComponent {
 
    constructor(
         private dialogRef: MatDialogRef<BookReceiptIndetailOfficerComponent>,
         @Inject(MAT_DIALOG_DATA) public data: any,
         private service: DigisubservicesService,
         private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
       ) {
       }
     
   
   
    PaymentBookOffInDFormBenas: any = []
    reportType:any
    startDate :any
    endDate :any
    repName :any
    offRepName:any
    billno:any
    bookSellerName :any
    issueDates:any
    issueDates1:any
  
  bookrcptregisterform = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      repwise: new FormControl(),
      officerepwise: new FormControl(),
      issuename: new FormControl(),
      billnowise:new FormControl(),
      booksellerwise: new FormControl(),
    });


     startDate_contract: any;
     enddate_contract: any;
     PaymentbookOffInDTotal2: number = 0;
     PaymentabookOffInDTotal3: number = 0;
     PaymentbookOffInDTotal: number = 0;
     ngOnInit(): void {
   
      debugger
      let repname: any = this.data['repName'];
   
       // Then check if it's not empty and convert to array
       if (repname != "") {
         repname = [repname]; // This puts the single value in an array
       }
   
       this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['officerepwise'] ;
      this.billno = this.data['billnowise'];
      this.bookSellerName = this.data['booksellerwise'];
  
  
      const req: any = {
        "rep_name": this.repName,
        "start_date": this.startDate,
        "end_date": this.endDate,
        "office_rep_name": this.offRepName,
        "book_seller_name":  this.bookSellerName,
        "bill_no": this.billno
      }
 
 
       // officer in detail
     this.service.getBookPaymentRegiOffInDetails(req).subscribe((data: any) => {
       console.log("new", data)
       this.PaymentBookOffInDFormBenas = data as any;
       console.log(this.PaymentBookOffInDFormBenas, "newlist 3 loop")
       // Reset totals
       // this.PaymentbookOffInDTotal = 0;
       this.PaymentbookOffInDTotal2 = 0;
       this.PaymentabookOffInDTotal3 = 0;
 
 
 
       // Calculate totals
       for (let repData of this.PaymentBookOffInDFormBenas) {
         this.PaymentbookOffInDTotal2 += parseInt(repData.total) || 0;
 
         for (let data1 of repData.rep_data) {
           // this.PaymentbookOffInDTotal += parseInt(data1.rcv_amt) || 0;
           // // this.PaymentbookOffInDTotal2 += parseInt(repdata.total) || 0;
           // this.PaymentabookOffInDTotal3 += parseInt(data1.rcv_amt) || 0;
         }
       }
       console.log("offcr total", this.PaymentbookOffInDTotal)
     });
 
     }
 
     printPage4() {
       // this.show = true;
       const printSection = document.getElementById('print-section');
       if (!printSection) {
         console.error("Print section not found!");
         return;
       }
   
       const printContent = printSection.innerHTML;
   
       const screenWidth = window.screen.availWidth;
       const windowWidth = 1400;
       const leftPosition = screenWidth - windowWidth - 50;
   
       const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);
   
       if (printWindow) {
         printWindow.document.open();
         printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page {
                                 size: A3 landscape;
                                 margin: 3mm;
                             }
                             .report-container {
     background: rgb(15, 15, 15);
     border-radius: 12px;
     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
     overflow: hidden;
     margin: 20px auto;
 }
 
 .report-header {
     background: #f8f9fa;
     color: #333333;
     padding: 20px;
     text-align: center;
 }
 
 .report-title {
     font-size: 18px;
     font-weight: bold;
     margin-bottom: 10px;
 }
 
 .report-subtitle {
     font-size: 14px;
     opacity: 0.9;
 }
 
 .table-responsive {
     overflow-x: auto;
     background: white;
 }
 
 .styled-table {
     width: 100%;
     border-collapse: collapse;
     font-size: 13px;
     font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 }
 
 .styled-table thead {
     background: #e9ecef;
     color: #495057;
 }
 
 .styled-table thead th {
     padding: 15px 10px;
     text-align: center;
     font-weight: 600;
     border: 1px solid #dee2e6;
     text-shadow: none;
 }
 
 .styled-table tbody td {
     padding: 8px 10px;
     border: 1px solid #e2e8f0;
     vertical-align: middle;
     color: #000000;
 }
 
 .styled-table tbody tr:nth-child(even) {
     background-color: #f8fafc;
 }
 
 .styled-table tbody tr:hover {
     background-color: #e2e8f0;
     transition: background-color 0.2s ease;
 }
 
 .office-header {
     background: #d1ecf1 !important;
     color: #0c5460 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .rep-header {
     background: #d4edda !important;
     color: #155724 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .rep-total {
     background: #fff3cd !important;
     color: #856404 !important;
     font-weight: bold !important;
     font-size: 13px !important;
 }
 
 .office-total {
     background: #f8d7da !important;
     color: #721c24 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .styled-table tfoot {
     background: #e9ecef;
     color: #495057;
 }
 
 .styled-table tfoot td {
     padding: 15px 10px;
     font-weight: bold;
     font-size: 16px;
     border: 1px solid #dee2e6;
 }
 
 .data-row td {
     font-size: 12px !important;
     font-weight: 500 !important;
     color: #000000 !important;
 }
 
 .amount-cell {
     font-family: 'Courier New', monospace !important;
     background: #f7fafc !important;
     color: #000000 !important;
 }
 
 .button-container {
     background: white;
     padding: 20px;
     display: flex;
     justify-content: flex-end;
     gap: 10px;
     border-top: 1px solid #e2e8f0;
 }
 
 .modern-btn {
     padding: 10px 20px;
     border: none;
     border-radius: 6px;
     cursor: pointer;
     font-weight: 600;
     text-transform: uppercase;
     letter-spacing: 0.5px;
     transition: all 0.3s ease;
     font-size: 12px;
 }
 
 .btn-primary-modern {
     background: #6c757d;
     color: white;
     box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4);
 }
 
 .btn-primary-modern:hover {
     transform: translateY(-2px);
     box-shadow: 0 6px 20px rgba(108, 117, 125, 0.6);
 }
 
 .btn-secondary-modern {
     background: #e2e8f0;
     color: #4a5568;
     border: 1px solid #cbd5e0;
 }
 
 .btn-secondary-modern:hover {
     background: #cbd5e0;
     transform: translateY(-1px);
 }    
                             body {
                                 font-family: Arial, sans-serif;
                                 margin: 0;
                                 padding: 0;
                                 font-size: 10px !important;
                             }
                             .print-section {
                                 width: 100%;
                                 margin: 0 auto;
                                 padding: 0;
                             }
                             table {
                                 width: 100% !important;
                                 border-collapse: collapse;
                                 table-layout: auto;
                                 page-break-inside: auto;
                             }
                             tr {
                                 page-break-inside: avoid;
                                 page-break-after: auto;
                             }
                             th, td {
                                 padding: 3px 5px !important;
                                 border: 1px solid black !important;
                                 font-size: 10px;
                                 line-height: 1.3;
                                 word-wrap: break-word;
                                 overflow-wrap: break-word;
                             }
                             th {
                                 background-color: #f2f2f2;
                             }
                             tr {
                                 border-bottom: 1px solid black !important;
                             }
                             tr.header-row {
                                 display: table-header-group;
                             }
                             td:nth-child(1) {
                                 width: 1%;
                                 text-align: left !important;
                             }
                             td:nth-child(2),
                             td:nth-child(3),
                             td:nth-child(4),
                             td:nth-child(5),
                             td:nth-child(6),
                             td:nth-child(8) {
                                 text-align: left !important;
                             }
                             td:nth-child(5) {
                                 width: 5%;
                                 white-space: normal;
                             }
                             td.advt-name {
                                 max-width: 160px;
                                 white-space: nowrap;
                                 overflow: hidden;
                                 text-overflow: ellipsis;
                             }
                             td:nth-child(n+12),
                             td.amount,
                             td[data-type="number"] {
                                 text-align: right !important;
                             }
                             td.text,
                             td[data-type="string"] {
                                 text-align: left !important;
                             }
                             .br-right { border-right: 1px solid black !important; }
                             .br-rightt { border-right: 4px solid black !important; }
                             .br-bottom { border-bottom: 2px solid black !important; }
                             .br-top { border-top: 2px solid black !important; }
                             .noPrint { display: none !important; }
                             .footer-line {
                                 position: fixed;
                                 bottom: 0;
                                 left: 0;
                                 width: 100%;
                                 height: 2px;
                                 background-color: black;
                             }
                             thead { display: table-header-group; }
                             tfoot { display: table-footer-group; }
                             td.balance-value {
                                 text-align: right !important;
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div class="print-section">
                         ${printContent}
                         <div class="footer-line"></div>
                     </div>
                     <script>
                        window.onload = function () {
       const table = document.querySelector('table');
       if (!table) {
           console.error("Table not found");
           return;
       }
   
       let headerRowIndex = -1;
       const maxRowsToCheck = Math.min(10, table.rows.length);
   
       // Find header row with column names
       for (let i = 0; i < maxRowsToCheck; i++) {
           const row = table.rows[i];
           const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
   
           if (row.cells.length >= 8 &&
               (cellTexts.includes('Invoice No') ||
                cellTexts.includes('Receipt No') ||
                cellTexts.includes('Balance'))) {
               headerRowIndex = i;
               break;
           }
       }
   
       if (headerRowIndex >= 0) {
           // Create thead and move only the actual header row into it
           let thead = table.querySelector('thead');
           if (!thead) {
               thead = document.createElement('thead');
               table.insertBefore(thead, table.firstChild);
           }
   
           const headerRow = table.rows[headerRowIndex];
           thead.appendChild(headerRow); // move actual header row
   
           // Leave the other rows (like titles) in tbody so they don’t repeat
       }
   
       // Alignment processing (no change needed here)
       const cells = document.querySelectorAll('td');
       cells.forEach(cell => {
           const content = cell.textContent.trim();
   
           if (content.includes('येणे') ||
               content.includes('Opening Balance') ||
               content.match(/^\d+\s+येणे$/) ||
               content.includes('Balance C/F') ||
               content.includes('Total')) {
               cell.style.textAlign = 'right';
               cell.classList.add('balance-value');
           }
   
           const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
           if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
               cell.style.textAlign = 'right';
               cell.classList.add('amount');
           }
       });
   
       setTimeout(() => {
           window.print();
           setTimeout(() => { window.close(); }, 500);
       }, 200);
   };
   
                     </script>
                 </body>
             </html>
         `);
         printWindow.document.close();
       } else {
         console.error("Failed to open print window.");
       }
     }
 
 
 
     exportExcel(fileName): void {
   console.log('Export function called with fileName:', fileName);
   
   let element = document.getElementById('print-section');
   console.log('Element found:', element);
   
   if (!element) {
     console.error('Element with ID "print-section" not found in DOM');
     return;
   }
   
   try {
     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
     console.log('Worksheet created:', ws);
     
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
     
     XLSX.writeFile(wb, fileName + '.xlsx');
     console.log('File should be downloaded');
   } catch (error) {
     console.error('Error during export:', error);
   }
 }
 

}
